// extracted by mini-css-extract-plugin
export default {"container":"logo_container__FPcdW","imageContainer":"logo_imageContainer__wwwnv","removeLogoModal":"logo_removeLogoModal__-jHIc"};